type ColorChartsType = Record<ColorChartVariants, ColorChartType>;

type ColorChartType = {
  title: string;
  colors: ColorChartItem[];
};

export type ColorModels = 'hex' | 'rgb' | 'cmyk' | 'pms';

export type ColorChartItem = {
  colorModels: Record<ColorModels, string>;
  border?: boolean;
};

export type ColorChartVariants =
  | 'blue'
  | 'grey'
  | 'blackWhite'
  | 'orange'
  | 'red'
  | 'green';

export const chartTabs: ColorModels[] = ['hex', 'rgb', 'cmyk', 'pms'];

const colorChartBlue: ColorChartItem[] = [
  {
    colorModels: {
      hex: '#202A44',
      rgb: '32/42/68',
      cmyk: '95/81/43/48',
      pms: '533 C',
    },
  },
  {
    colorModels: {
      hex: '#1B365D',
      rgb: '27/54/93',
      cmyk: '99/80/36/28',
      pms: '534 C',
    },
  },
  {
    colorModels: {
      hex: '#7089AC',
      rgb: '112/137/172',
      cmyk: '61/40/18/3',
      pms: '535 C',
    },
  },
  {
    colorModels: {
      hex: '#CED9E5',
      rgb: '206/217/229',
      cmyk: '23/11/7/0',
      pms: '650 C',
    },
  },
];

const colorChartGrey: ColorChartItem[] = [
  {
    colorModels: {
      hex: '#53565A',
      rgb: '83/86/90',
      cmyk: '63/51/43/40',
      pms: 'Cool Grey 11 C',
    },
  },
  {
    colorModels: {
      hex: '#888B8D',
      rgb: '136/139/141',
      cmyk: '47/36/35/15',
      pms: 'Cool Gray 8 C',
    },
  },
  {
    colorModels: {
      hex: '#A7A8A9',
      rgb: '167/168/169',
      cmyk: '37/28/28/7',
      pms: 'Cool Gray 5 C',
    },
  },
  {
    colorModels: {
      hex: '#C8C9C7',
      rgb: '200/201/199',
      cmyk: '25/18/20/1',
      pms: 'Cool Gray 3 C',
    },
  },
  {
    colorModels: {
      hex: '#E1DFDD',
      rgb: '225/223/221',
      cmyk: '14/11/13/0',
      pms: 'Cool Gray 1 C',
    },
  },
];

const colorChartBlackWhite: ColorChartItem[] = [
  {
    colorModels: {
      hex: '#000000',
      rgb: '0/0/0',
      cmyk: '00/00/00/100',
      pms: 'Black',
    },
  },
  {
    colorModels: {
      hex: '#141414',
      rgb: '20/20/20',
      cmyk: 'N/A',
      pms: 'N/A',
    },
  },
  {
    colorModels: {
      hex: '#FFFFFF',
      rgb: '255/255/255',
      cmyk: '0/0/0/0',
      pms: 'White',
    },
    border: true,
  },
];

const colorChartOrange: ColorChartItem[] = [
  {
    colorModels: {
      hex: '#A85F02',
      rgb: '168/95/2',
      cmyk: '0/43/99/34',
      pms: '146 C',
    },
  },
  {
    colorModels: {
      hex: '#BF834B',
      rgb: '191/131/75',
      cmyk: '0/31/61/25',
      pms: '722 C',
    },
  },
  {
    colorModels: {
      hex: '#D9B48B',
      rgb: '217/180/139',
      cmyk: '0/17/36/15',
      pms: '3596 C',
    },
  },
  {
    colorModels: {
      hex: '#F0DFC6',
      rgb: '240/223/198',
      cmyk: '0/7/17/6',
      pms: '7506 C',
    },
  },
];

const colorChartRed: ColorChartItem[] = [
  {
    colorModels: {
      hex: '#622128',
      rgb: '98/33/40',
      cmyk: '0/66/59/62',
      pms: '4101 C',
    },
  },
  {
    colorModels: {
      hex: '#9E2A2B',
      rgb: '158/42/43',
      cmyk: '0/73/73/38',
      pms: '7628 C',
    },
  },
  {
    colorModels: {
      hex: '#DDA69D',
      rgb: '221/166/157',
      cmyk: '0/25/29/13',
      pms: '2444 C',
    },
  },
  {
    colorModels: {
      hex: '#F0DDD7',
      rgb: '240/221/215',
      cmyk: '0/8/10/6',
      pms: '9241 C',
    },
  },
];

const colorChartGreen: ColorChartItem[] = [
  {
    colorModels: {
      hex: '#22372B',
      rgb: '34/55/43',
      cmyk: '38/0/22/78',
      pms: '5605 C',
    },
  },
  {
    colorModels: {
      hex: '#476D3B',
      rgb: '71/109/59',
      cmyk: '35/0/46/57',
      pms: '2265 C',
    },
  },
  {
    colorModels: {
      hex: '#A3B2A4',
      rgb: '163/178/164',
      cmyk: '8/0/8/30',
      pms: '5645 C',
    },
  },
  {
    colorModels: {
      hex: '#E0E7D9',
      rgb: '224/230/217',
      cmyk: '3/0/6/9',
      pms: '9042 C',
    },
  },
];

export const colorCharts: ColorChartsType = {
  blue: {
    title: 'Blue colours',
    colors: colorChartBlue,
  },
  grey: {
    title: 'Grey colours',
    colors: colorChartGrey,
  },
  blackWhite: {
    title: 'Black/White',
    colors: colorChartBlackWhite,
  },
  orange: {
    title: 'Orange colours',
    colors: colorChartOrange,
  },
  red: {
    title: 'Red colours',
    colors: colorChartRed,
  },
  green: {
    title: 'Green colours',
    colors: colorChartGreen,
  },
};
